const PhoneIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
  </svg>
);

const Header = () => (
  <header className="ppb-header">
    <div className="container ppb-header-row">
      <a href="#top" className="ppb-brand" aria-label="Groupe Scolaire Sanaa">
        <img src="/logo-gssanaa-text.webp" alt="Groupe Scolaire Sanaa" />
        <span className="ppb-brand-tag">Prépa Post-Bac</span>
      </a>
      <a
        href="tel:0522930408"
        className="ppb-header-phone"
        aria-label="Appeler le 05 22 93 04 08"
      >
        <PhoneIcon />
        <span>05 22 93 04 08</span>
      </a>
    </div>
  </header>
);

export default Header;
